import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

// Provide a first-class way to render children into a DOM node
// that exists outside the DOM hierarchy of the parent component.
export const Portal = ({ children, className = 'root-portal', el = 'div' }) => {
  const [container] = useState(document.createElement(el));
  container.classList.add(className);

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return createPortal(children, container);
};
